export default __webpack_public_path__ + "static/media/logo_completa_branca.314cf287.svg";